
namespace ui
{
	export namespace tree
	{
		export class Node
			extends AbstractNode
		{
			private m_Disabled: boolean;
			private m_Checkbox: JQuery;
			private m_Label: JQuery;
			private m_Icon: JQuery;

			private m_cbfn: (...args: any[]) => any;

			private m_List: TreeView;

			public constructor( label: string, view: JQuery|ui.base.BaseHTMLElement )
			{
				super( 'li', view );

				const checkID = ui.utils.UUID.Gen();

				this.m_Icon			= ui.$$.i().addClass('fa');
				this.m_Label		= ui.$$.label().append(this.m_Icon).append( label ).attr('for', checkID);
				this.m_Checkbox	= ui.$$.input().attr( 'type', 'checkbox' ).attr( 'id', checkID );

				this.m_Disabled	= false;

				this.m_List			= new TreeView( this.m_Root );

				this.m_cbfn			= () => { return; };
			}

			public OnClickFN( callbackFn: (...args: any[]) => any ): void
			{
				this.m_cbfn = callbackFn;
			}

			public appendNewNode( label: string ): Node
			{
				const node = new Node( label, this.m_List );

				super.addNode( node );

				return node;
			}

			public setIcon( icon: string ): void
			{
				this.m_Icon.removeClass();

				this.m_Icon.addClass( 'fa' );
				this.m_Icon.addClass( 'fa-' + icon );
			}

			public rebuild(): void
			{
				this.empty();
				this.remove();

				this.append( this.m_Checkbox )
					.append( this.m_Label );

				if ( this.m_Nodes.length > 0 )
				{
					this.append( this.m_List );
				}

				super.rebuild();

				// @ts-ignore
				this.m_Checkbox.click( this.m_cbfn );
			}

			public Disable( disabled: boolean ): void
			{
				this.m_Disabled = disabled;

				this.m_Checkbox.prop( 'disabled', disabled );
			}

			public Disabled(): boolean { return this.m_Disabled; }
		}
	}
}
